import {
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

type SearchHeroVisibilityContextType = {
  /** Is intentionally undefined on SSR. Check explicitly for false. */
  heroInView?: boolean;
  setHeroInView: Dispatch<SetStateAction<boolean | undefined>>;
};

export type SearchHeroVisibilityProviderProps = {
  children: ReactNode;
};

const SearchHeroVisibilityContext = createContext<
SearchHeroVisibilityContextType | undefined
>(undefined);

const SearchHeroVisibilityProvider: FC<SearchHeroVisibilityProviderProps> = ({
  children,
}) => {
  const [heroInView, setHeroInView] = useState<boolean | undefined>(
    undefined, // some headers check for undefined on SSR, until set by useIntersectionObserver
  );

  const contextValue = useMemo(() => ({
    heroInView,
    setHeroInView,
  }), [heroInView]);

  return (
    <SearchHeroVisibilityContext.Provider value={contextValue}>
      {children}
    </SearchHeroVisibilityContext.Provider>
  );
};
export default SearchHeroVisibilityProvider;

/**
 * @warning This is an optional context. It will fail silently if no provider is used.
 */
export const useSearchHeroVisibilityContext = (): SearchHeroVisibilityContextType => {
  const context = useContext(SearchHeroVisibilityContext);

  /** Optional context */
  if (!context) {
    return {} as SearchHeroVisibilityContextType;
  }
  return context;
};
